export default "__VITE_ASSET__BMHy46FN__"